export const localStorageGet = (key) => {
  let data = JSON.parse(localStorage.getItem(key))
  if (data !== null) {
    if (data.expirse != null && data.expirse < new Date().getTime()) {
      localStorage.removeItem(key)
    } else {
      return data.value
    }
  }
  return null
}



// WEBPACK FOOTER //
// ./src/utils/localStorageGet.js